import type { LucideIcon } from 'lucide-react';
import { ArrowLeft, Construction } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PlaceholderPageProps {
  title: string;
  eyebrow: string;
  description: string;
  icon?: LucideIcon;
}

export function PlaceholderPage({ title, eyebrow, description, icon: Icon = Construction }: PlaceholderPageProps) {
  return (
    <main className="placeholder-page">
      <div className="placeholder-card">
        <span className="placeholder-icon"><Icon size={28} /></span>
        <p className="app-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{description}</p>
        <div className="placeholder-note">
          <Construction size={18} />
          <span><strong>Struttura pronta</strong>Questa sezione verrà definita nel prossimo recap funzionale.</span>
        </div>
        <Link className="button button-secondary" to="/app"><ArrowLeft size={16} /> Torna alla Home</Link>
      </div>
    </main>
  );
}
